<template>
  <div class="content">
    <el-row type="flex">
      <el-col :span="12">
        <h3>{{ form.remark }}</h3>
        <el-form
          label-position="top"
          :rules="rules"
          ref="form"
          label-width="80px"
          :model="form"
        >
          <!-- <el-form-item label="中文文档名称" prop="lang_list[1].title">
            <el-input
              v-model="form.lang_list[1].title"
              placeholder="请输入文档名称"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="中文文档内容" prop="lang_list[1].content">
            <tinymce
              :height="400"
              v-model="form.lang_list[1].content"
              :value="form.lang_list[1].content"
              ref="tinymce"
            />
          </el-form-item>
          <!-- <el-form-item label="英文文档名称" prop="lang_list[0].title">
            <el-input
              v-model="form.lang_list[0].title"
              placeholder="请输入文档名称"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="英文文档内容" prop="lang_list[0].content">
            <tinymce
              :height="400"
              v-model="form.lang_list[0].content"
              :value="form.lang_list[0].content"
              ref="tinymce"
            />
          </el-form-item>
          <el-form-item>
            <el-row type="flex" justify="center">
              <el-button @click="back"> 返回 </el-button>
              <el-button type="primary" @click="store" :loading="btnLoading">
                保存
              </el-button>
            </el-row>
          </el-form-item>
        </el-form></el-col
      >
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
import Tinymce from '@/components/Tinymce'
export default {
  components: { Tinymce },
  data() {
    return {
      btnLoading: false,
      rules: {
        // 'lang_list[0].title': [
        //   {
        //     required: true,
        //     message: '该项不能为空，请输入',
        //     trigger: 'change',
        //   },
        // ],
        // 'lang_list[1].title': [
        //   {
        //     required: true,
        //     message: '该项不能为空，请输入',
        //     trigger: 'change',
        //   },
        // ],
      },
      form: {
        id: '',
        lang_list: [
          {
            lang: 'en_US',
            title: '',
            content: '',
          },
          {
            lang: 'zh-CN',
            title: '',
            content: '',
          },
        ],
      },
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id
      this.detail()
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    detail() {
      request({
        url: '/api/backend/doc/detail',
        method: 'get',
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = res.data
        }
      })
    },
    store() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/doc/store',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.$router.push({
                path: '/operation/doclist',
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
</style>
